import axios from 'axios';
import { apiRoot } from '@/config/config';
import userInfo from "@/Components/user";

// const token = userInfo.getToken();
const token = userInfo?.access_token;

//读取一个任务（jobs）
export async function getJob(id: any) {
  return await axios({
    url: `${apiRoot}/jobs/${id}`,
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//读取任务列表（jobs）
export async function jobs(params: any) {
  return await axios({
    url: `${apiRoot}/jobs`,
    method: 'GET',
    params,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//更新job
export async function updateJob(job_id: any, data: any) {
  return await axios({
    url: `${apiRoot}/jobs/${job_id}`,
    method: 'PUT',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//创建任务（jobs）
export async function createJobs(data: any, tag: string) {
  return await axios({
    url: `${apiRoot}/jobs/${tag}`,
    method: 'POST',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//删除Job
export async function deleteJob(id: any) {
  return await axios({
    url: `${apiRoot}/jobs/${id}`,
    method: 'delete',
    // params:{id},
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//清空全部任务
export async function clearAllJobs(flow_id: any) {
  return await axios({
    url: `${apiRoot}/jobs/byFlows/${flow_id}`,
    method: 'delete',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//创建用户任务信息
export async function userJobInteraction(data: any) {
  return await axios({
    url: `${apiRoot}/user_job_interactions`,
    method: 'POST',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//获取各用户的计算次数统计
export async function getUserJobInteractionCounts() {
  return await axios({
    url: `${apiRoot}/user_job_interactions/user_counts`,
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//获取某用户提交的任务记录（分页）
export async function getUserJobInteractions(params: { user_id: number; page?: number; page_size?: number }) {
  return await axios({
    url: `${apiRoot}/user_job_interactions`,
    method: 'GET',
    params,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
